import { Routes } from '@angular/router';
import { AuthGuardService } from '@shared/guards/auth-guard.service';

export const PagesRoutes: Routes = [
  { // TODO remove, when sixbid got updated
    path: 'iframes',
    redirectTo: 'sixbid-livebidding'
  },
  {
    path: 'sixbid-livebidding',
    children: [ // TODO probably not lazy loaded
      {
        path: '**',
        loadComponent: () => import('./sixbid-livebidding/sixbid-livebidding.component').then((m) => m.SixbidLivebiddingComponent),
        data: { updatePolicy: 'instant' }
      }
    ]
  },
  {
    path: 'floorview',
    children: [  // TODO probably not lazy loaded
      {
        path: '**',
        loadComponent: () => import('./floorview/floorview.component').then((m) => m.FloorviewComponent),
        data: { updatePolicy: 'instant' }
      }
    ]
  },
  {
    path: ':locale',
    loadComponent: () => import('./pages.component').then((m) => m.PagesComponent),
    children: [
      {
        path: 'auctions',
        loadChildren: () => import('./auctions/auctions.routes').then((m) => m.AuctionsRoutes)
      },
      {
        // TODO remove after a while - still present in order to prevent breaking existing mails
        path: 'account/lots',
        pathMatch: 'full',
        redirectTo: 'my/lots'
      },
      {
        // TODO remove after a while - still present in order to prevent breaking existing mails
        path: 'account/settings',
        pathMatch: 'full',
        redirectTo: 'my/settings'
      },
      {
        // TODO remove after a while - still present in order to prevent breaking existing mails
        path: 'account/statistics',
        pathMatch: 'full',
        redirectTo: 'my/statistics'
      },
      {
        // TODO remove after a while - still present in order to prevent breaking existing mails
        path: 'account/mailbox',
        pathMatch: 'full',
        redirectTo: 'my/mailbox'
      },
      {
        // TODO remove after a while - still present in order to prevent breaking existing mails
        path: 'verify',
        pathMatch: 'prefix',
        redirectTo: 'account/verify'
      },
      {
        // TODO remove after a while - still present in order to prevent breaking existing mails
        path: 'reset-password',
        pathMatch: 'prefix',
        redirectTo: 'account/reset-password'
      },
      {
        // TODO remove after a while - still present in order to prevent breaking existing mails
        path: 'account',
        loadChildren: () => import('./account/account.routes').then((m) => m.AccountRoutes)
      },
      {
        path: 'catalog',
        pathMatch: 'full',
        redirectTo: 'auctions/lots'
      },
      {
        path: 'my',
        loadChildren: () => import('./my/my.routes').then((m) => m.MyRoutes),
        canActivate: [AuthGuardService]
      },
      {
        // TODO REMOVE when not required anymore
        path: 'lot',
        redirectTo: (route) => {
          if (!route.queryParams.$goto?.length) {
            return '/';
          }
          // fake route-lang because we do not have access to localizeRoutePipe here
          return `/fa-ke/auctions/lots/${route.queryParams.$goto}`;
        }
      },
      {
        path: 'live',
        loadComponent: () => import('./live/live.component').then((m) => m.LiveComponent),
        data: { updatePolicy: 'instant' }
      },
      {
        path: 'shop',
        loadChildren: () => import('./shop/shop.routes').then((m) => m.ShopRoutes)
      },
      {
        path: 'licenses',
        loadComponent: () => import('./licenses/licenses.component').then((m) => m.LicensesComponent)
      },
      {
        path: '',
        redirectTo: 'auctions/current',
        pathMatch: 'full'
      },
      {
        path: '**',
        pathMatch: 'full',
        loadComponent: () => import('./not-found/not-found.component').then((m) => m.NotFoundComponent)
      }
    ]
  }
];
